<template>
  <div class="list">
    <div
      :class="['district', item.districtID === currentCityId ? 'active' : '']"
      v-for="item in cityList"
      :key="item.districtID"
      @click="selectItem(item)"
    >
      {{ item.districtName }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watchEffect, defineProps, defineEmits, defineExpose } from 'vue';
import type { District } from '../../../api/types';
import { request } from '../../../api/request';

const props = defineProps<{ provinceDistrID: string }>()
const emit = defineEmits(['select'])
const cityList = ref<District[]>([])
const currentCityId = ref('')

watchEffect(async () => {
  if (!props.provinceDistrID) return

  const data = await request('web.basicBiz.address.getMultiLevelSubList', {
    commonDistrID: props.provinceDistrID
  })
  cityList.value = data.districtList
})

const selectItem = (item) => {
  console.log(item, '市区')
  currentCityId.value = item.districtID
  emit('select', item)
}

defineExpose({
  reset: () => currentCityId.value = ''
})
</script>


<style scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  justify-content: flex-start;
  align-items: flex-start;
}

.district {
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;

  &:hover {
    color: #7E51E4;
  }
}
.district.active {
  color: #7E51E4;
}

.district {
  padding: 5px 10px;
  color: #24262B;
}
</style>